var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAddDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_add_devices") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.023529 0 0 0 0 0.454902 0 0 0 0 0.623529 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_add_devices",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Group-38"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75,1.875 C3.75,2.21875 3.46875,2.5 3.125,2.5 L2.5,2.5 L2.5,3.125 C2.5,3.46875 2.21875,3.75 1.875,3.75 C1.53125,3.75 1.25,3.46875 1.25,3.125 L1.25,2.5 L0.625,2.5 C0.28125,2.5 0,2.21875 0,1.875 C0,1.53125 0.28125,1.25 0.625,1.25 L1.25,1.25 L1.25,0.625 C1.25,0.28125 1.53125,0 1.875,0 C2.21875,0 2.5,0.28125 2.5,0.625 L2.5,1.25 L3.125,1.25 C3.46875,1.25 3.75,1.53125 3.75,1.875 Z",
    id: "Path-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(1.875000, 1.875000) scale(-1, -1) translate(-1.875000, -1.875000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,4.4408921e-16 L5.5,4.4408921e-16 C5.225,4.4408921e-16 5,0.28125 5,0.625 C5,0.96875 5.225,1.25 5.5,1.25 L9.5,1.25 C9.775,1.25 10,0.96875 10,0.625 C10,0.28125 9.775,4.4408921e-16 9.5,4.4408921e-16 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(7.500000, 0.625000) scale(-1, -1) translate(-7.500000, -0.625000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375,5 L0.625,5 C0.28125,5 0,5.28125 0,5.625 C0,5.96875 0.28125,6.25 0.625,6.25 L9.375,6.25 C9.71875,6.25 10,5.96875 10,5.625 C10,5.28125 9.71875,5 9.375,5 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(5.000000, 5.625000) scale(-1, -1) translate(-5.000000, -5.625000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3125,3.75 L9.6875,3.75 C9.859375,3.75 10,3.46875 10,3.125 C10,2.78125 9.859375,2.5 9.6875,2.5 L5.3125,2.5 C5.140625,2.5 5,2.78125 5,3.125 C5,3.46875 5.140625,3.75 5.3125,3.75 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(7.500000, 3.125000) scale(-1, -1) translate(-7.500000, -3.125000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8.125 C0,8.46875 0.28125,8.75 0.625,8.75 L9.375,8.75 C9.71875,8.75 10,8.46875 10,8.125 C10,7.78125 9.71875,7.5 9.375,7.5 L0.625,7.5 C0.28125,7.5 0,7.78125 0,8.125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(5.000000, 8.125000) scale(-1, -1) translate(-5.000000, -8.125000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddDevices);
export default __webpack_public_path__ + "static/media/icon_add_devices.a535e5062630fbcd4ea0bfb2f1f7baed.svg";
export { ForwardRef as ReactComponent };